import { TextField, TextFieldProps } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { ErrorMessage } from '../ErrorMessage'

type Props = TextFieldProps & {
  name: string
}

const TextArea = ({ name, ...props }: Props) => {
  const { control, formState } = useFormContext()
  const { errors } = formState

  const error = errors?.[name]
  const hasError = Boolean(error)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
          <TextField {...props} error={hasError} onChange={onChange} value={value} />
          {hasError && <ErrorMessage message={error.message} />}
        </>
      )}
    />
  )
}

export { TextArea }
